import aa from "search-insights";

export const initializeInsights = () => {
  if (typeof aa === "function") {
    aa("init", {
      appId: algolia.application_id,
      apiKey: algolia.search_api_key,
      userToken: algolia.user_info.user_token,
      useCookies: true,
      debug: true,
    });
    window.aa = aa;
  }
};

export const trackItemClick = (hit, eventName = "Product Clicked") => {
  console.log("Tracking item click:", hit, eventName);
  if (!hit.objectID || !hit.__queryID || !hit.__position) {
    return;
  }
  if (typeof window.aa !== "function") {
    return;
  }
  try {
    window.aa("clickedObjectIDsAfterSearch", {
      userToken: algolia.user_info.user_token,
      index: algolia.product_index_name,
      eventName: eventName,
      objectIDs: [hit.objectID],
      queryID: hit.__queryID,
      positions: [hit.__position],
    });
  } catch (error) {
    console.error("Error sending click event to Algolia:", error);
  }
};

export const trackConversion = (hit, eventName = "add_to_cart") => {
  if (!hit.objectID || !hit.__queryID) {
    return;
  }
  if (typeof window.aa !== "function") {
    return;
  }
  try {
    window.aa("convertedObjectIDsAfterSearch", {
      userToken: algolia.user_info.user_token,
      index: algolia.product_index_name,
      eventName: eventName,
      objectIDs: [hit.objectID],
      queryID: hit.__queryID,
    });
  } catch (error) {
    console.error("Error sending conversion event to Algolia:", error);
  }
};

export const trackAddToCart = (props) => {
  const { productId, qty } = props;
  if (!productId) {
    return;
  }
  if (typeof window.aa !== "function") {
    console.error("Algolia Insights (aa) is not defined on window object");
    return;
  }
  try {
    window.aa("addedToCartObjectIDs", {
      userToken: algolia.user_info.user_token,
      index: algolia.product_index_name,
      eventName: "add_to_cart",
      objectIDs: [productId],
    });
    console.log("addedToCart event sent.");
  } catch (error) {
    console.error("Error sending addToCart event to Algolia", error);
  }
};

/**
 * Forward eCommerce events from dataLayer to Algolia Insights
 */
(function () {
  if (typeof window === "undefined") return;

  var DEDUPE_WINDOW_MS = 5000;
  var recentSends = {};

  function resolveObjectId(item) {
    if (!item || typeof item !== "object") return null;

    var rawId =
      item.product_id ||
      item.productId ||
      item.wc_product_id ||
      item.objectID ||
      item.objectId ||
      item.item_id ||
      item.id ||
      item.itemId ||
      item.itemNumber ||
      null;

    if (!rawId) return null;

    var strId = String(rawId).trim();

    var numericId = strId.replace(/\D+/g, "");

    numericId = numericId.replace(/^0+/, "");

    if (numericId && /^\d+$/.test(numericId)) {
      return numericId;
    }

    return strId;
  }

  function shouldSend(key) {
    var now = Date.now();
    var last = recentSends[key] || 0;
    if (now - last < DEDUPE_WINDOW_MS) {
      return false;
    }
    recentSends[key] = now;
    return true;
  }

  function forwardEventToAlgolia(eventName, items, extras) {
    if (!window.aa || typeof window.aa !== "function") return;
    items = items || [];
    var objectIDs = items.map(resolveObjectId).filter(function (v) {
      return v;
    });
    if (!objectIDs.length) return;

    // dedupe per eventName|id
    var toSend = objectIDs.filter(function (id) {
      return shouldSend(eventName + "|" + id);
    });
    if (!toSend.length) return;

    try {
      if (
        eventName === "purchase_complete" ||
        eventName === "begin_checkout" ||
        eventName === "add_shipping_info" ||
        eventName === "add_payment_info" ||
        eventName === "remove_from_cart" ||
        eventName === "view_cart" ||
        eventName === "mini_cart_toggle"
      ) {
        window.aa("convertedObjectIDsAfterSearch", {
          userToken: algolia.user_info.user_token,
          index: algolia.product_index_name,
          eventName: eventName,
          objectIDs: toSend,
          ...(extras || {}),
        });
        return;
      }

      if (eventName === "pdp_view" || eventName === "plp_view" || eventName === "view_item") {
        try {
          window.aa("viewedObjectIDs", {
            userToken: algolia.user_info.user_token,
            index: algolia.product_index_name,
            eventName: eventName,
            objectIDs: toSend,
          });
        } catch (err) {
          // If views are rejected, fallback to converted
          if (err && err.message && err.message.indexOf("View events are ignored") !== -1) {
            window.aa("convertedObjectIDsAfterSearch", {
              userToken: algolia.user_info.user_token,
              index: algolia.product_index_name,
              eventName: eventName + "_as_view_fallback",
              objectIDs: toSend,
              ...(extras || {}),
            });
          }
        }
        return;
      }

      // fallback
      window.aa("convertedObjectIDsAfterSearch", {
        userToken: algolia.user_info.user_token,
        index: algolia.product_index_name,
        eventName: eventName,
        objectIDs: toSend,
        ...(extras || {}),
      });
    } catch (e) {
      if (window && window.console) console.warn("Algolia forward error", e);
    }
  }

  function handlePayload(payload) {
    if (!payload || typeof payload !== "object") return;
    var event = payload.event;
    if (!event) return;

    var items = (payload.ecommerce && payload.ecommerce.items) || payload.items || payload.topProducts || [];
    if ((!items || items.length === 0) && payload.categoryPage && Array.isArray(payload.categoryPage.topProducts)) {
      items = payload.categoryPage.topProducts;
    }

    var extras = {};
    if (payload.ecommerce && typeof payload.ecommerce.value !== "undefined") {
      extras.value = payload.ecommerce.value;
      if (payload.ecommerce.currency) extras.currency = payload.ecommerce.currency;
    } else if (payload.value) {
      extras.value = payload.value;
    }
    if (typeof payload.cart_status !== "undefined") {
      extras.cart_status = payload.cart_status;
    } else if (typeof payload.cartStatus !== "undefined") {
      extras.cart_status = payload.cartStatus;
    }

    var forwardList = [
      "purchase_complete",
      "begin_checkout",
      "add_shipping_info",
      "add_payment_info",
      "mini_cart_toggle",
      "remove_from_cart",
      "view_cart",
      "pdp_view",
      "plp_view",
      "view_item",
    ];

    if (forwardList.indexOf(event) !== -1) {
      forwardEventToAlgolia(event, items, extras);
    }
  }

  function patchDataLayer() {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.forEach(handlePayload);
      if (window.dataLayer.__algoliaForwarderPatched) return;
      var original = window.dataLayer.push.bind(window.dataLayer);
      window.dataLayer.push = function () {
        var res = original.apply(null, arguments);
        try {
          Array.from(arguments).forEach(function (a) {
            handlePayload(a);
          });
        } catch (e) {
          if (window && window.console) console.warn("dataLayer forward error", e);
        }
        return res;
      };
      window.dataLayer.__algoliaForwarderPatched = true;
    } catch (e) {
      if (window && window.console) console.warn("Failed to patch dataLayer", e);
    }
  }

  // Wait for window.aa to be available (since initializeInsights() will set it)
  var waited = 0;
  var interval = setInterval(function () {
    if (window.aa && typeof window.aa === "function") {
      clearInterval(interval);
      patchDataLayer();
    }
    waited += 100;
    if (waited > 10000) {
      clearInterval(interval);
    }
  }, 100);
})();
